import { type UserAppMetadata } from "@supabase/supabase-js";

import { PERMISSIONS_VERSION, UserRole } from "@fitness-app/data-models";

const permissionIdentityKeys = ["role", "memberId", "memberRole", "trainerId", "status"] as const;
const staffRoles = new Set<unknown>([UserRole.TRAINER, UserRole.TEAM_MEMBER]);

const isRecord = (value: unknown): value is Record<string, unknown> =>
  Boolean(value) && typeof value === "object" && !Array.isArray(value);

const haveEqualPermissionMaps = (first: unknown, second: unknown): boolean => {
  if (!isRecord(first) || !isRecord(second)) {
    return first === second;
  }

  const firstKeys = Object.keys(first);
  const secondKeys = Object.keys(second);

  return firstKeys.length === secondKeys.length && firstKeys.every((key) => first[key] === second[key]);
};

export const shouldRefreshPermissions = (
  sessionMetadata: UserAppMetadata,
  liveMetadata: UserAppMetadata = sessionMetadata,
): boolean => {
  const isStaff = staffRoles.has(sessionMetadata.role) || staffRoles.has(liveMetadata.role);

  if (!isStaff) {
    return false;
  }

  return (
    liveMetadata.permissionsVersion !== PERMISSIONS_VERSION ||
    sessionMetadata.permissionsVersion !== liveMetadata.permissionsVersion ||
    permissionIdentityKeys.some((key) => sessionMetadata[key] !== liveMetadata[key]) ||
    !haveEqualPermissionMaps(sessionMetadata.permissions, liveMetadata.permissions)
  );
};
